import { useQuery } from '@northladder/services';

import { IVerifyResetPasswordTokenParams } from '../types';
import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

const QRY_VALIDATE_RESET_TOKEN = 'validate-reset-token';

interface IValidateResetTokenOptions {
  params: IVerifyResetPasswordTokenParams;
  enabled?: boolean;
}

/**
 * Custom hook to validate a password reset token.
 */
export const useValidateResetTokenQuery = ({
  params,
  enabled = true,
}: IValidateResetTokenOptions) => {
  const { resetToken } = params;
  const { data, error, isPending } = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [QRY_VALIDATE_RESET_TOKEN, resetToken],
    queryFn: () => USER_ACCOUNTS_API.validateResetToken(params),
    enabled,
    networkMode: 'always',
    retry: false,
  });

  return {
    data,
    error,
    isPending,
  };
};
